module.exports = __webpack_public_path__ + "img/柳屯镇.41906491.png";